(function () {
  function enhanceCloudSearch() {
    document.querySelectorAll('#cloud-search-results .see-more-results a').forEach(function (link) {
      var term = link.querySelector('.actual-search-term');

      if (!term) return;

      var query = term.textContent.trim();
      var expectedText = 'See all results for “' + query + '”';

      if (link.dataset.xsSearchEnhanced === 'true' && link.textContent.trim() === expectedText) return;

      var termLabel = document.createElement('span');
      termLabel.className = 'actual-search-term';
      termLabel.textContent = query;

      link.dataset.xsSearchEnhanced = 'true';
      link.setAttribute('aria-label', 'See all results for ' + query);
      link.replaceChildren(
        document.createTextNode('See all results for “'),
        termLabel,
        document.createTextNode('”')
      );
    });
  }

  enhanceCloudSearch();

  new MutationObserver(enhanceCloudSearch).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
